import { Tab, Tabs } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import TabPanel from 'commons/TabPanel';

import ShareTabCreateShareLink from './ShareTabCreateShareLink';
import ShareTabInviteUser from './ShareTabInviteUser';

const ShareModalTab = ({ classes, onClose }) => {
  const { t } = useTranslation();
  const [tabValue, setTabValue] = useState(1);

  const handleChangeTab = (_, newValue) => {
    setTabValue(newValue);
  };

  return (
    <div className={classes.tabWrapper}>
      <Tabs
        value={tabValue}
        onChange={handleChangeTab}
        className={classes.tabs}
        TabIndicatorProps={{ className: classes.tabIndicator }}
      >
        <Tab
          value={1}
          label={t('invite_user')}
          className={classes.tab}
        />
        <Tab
          value={2}
          label={t('create_share_link')}
          className={classes.tab}
        />
      </Tabs>

      <div className={classes.tabPanel}>
        <TabPanel
          value={tabValue}
          index={1}
        >
          <ShareTabInviteUser
            classes={classes}
            onClose={onClose}
          />
        </TabPanel>

        <TabPanel
          value={tabValue}
          index={2}
        >
          <ShareTabCreateShareLink
            classes={classes}
            onClose={onClose}
          />
        </TabPanel>
      </div>
    </div>
  );
};

export default ShareModalTab;
